import CloseIcon from '@mui/icons-material/Close';
import PlayIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Button from 'components/Button/Button';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useTimer from '../../utils/useTimer';

const Popup = styled('div')`
  background-color: ${({ theme }) => theme.palette.background.paper};
  box-shadow: 0px 11px 20px 0px rgba(0, 8, 102, 0.1);
  max-width: 450px;
  margin: auto;
  text-align: center;
  padding-bottom: 16px;
  margin-bottom: 160px;
  .header {
    background-color: ${(p) => p.color};
    padding: 20px;
    position: relative;
    color: #ffffff;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }
  .video {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e4e7eb;
    max-width: 275px;
    height: 160px;
    margin: 20px auto;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2);
  }
  .close {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 14px;
  }
  .MuiButton-root {
    padding-left: 50px;
    padding-right: 50px;
    border-radius: 4px;
    border-width: 2px;
    font-weight: 500;
  }
`;

const CountDownValue = ({ value, unit }) => (
  <Box>
    <Typography fontWeight={600} variant="h4">
      {value}
    </Typography>
    <Typography
      color="text.secondary"
      variant="subtitle1"
      textTransform="uppercase"
    >
      {unit}
    </Typography>
  </Box>
);

const PopUpPreview = ({ popup, color }) => {
  const account = useSelector((state) => state.settings.account);
  const { enabled, title, buttonText, countdownType, videoUrl } = popup;
  const { days, hours, minutes, seconds } = useTimer(
    popup,
    account.account_timezone,
  );

  return (
    <Box pt={6} className="widget-preview">
      {enabled && (
        <Popup className="popup" color={color}>
          <div className="header">
            <div className="close">
              <CloseIcon fontSize="inherit" />
            </div>
            <Typography
              gutterBottom
              variant="h4"
              fontWeight={500}
              color="inherit"
              maxWidth={250}
            >
              {title}
            </Typography>
          </div>
          {videoUrl && (
            <div className="video">
              <PlayIcon />
            </div>
          )}
          <Button variant="outlined">{buttonText}</Button>
          {countdownType && (
            <Box mt={2}>
              <Typography paragraph fontWeight={500} variant="subtitle1">
                Next service begins in
              </Typography>
              <div className="countdown">
                <Stack direction="row" spacing={3} justifyContent="center">
                  <CountDownValue value={days} unit="Days" />
                  <CountDownValue value={hours} unit="Hours" />
                  <CountDownValue value={minutes} unit="Minutes" />
                  <CountDownValue value={seconds} unit="Seconds" />
                </Stack>
              </div>
            </Box>
          )}
        </Popup>
      )}
    </Box>
  );
};

export default PopUpPreview;
